import React, { useEffect, useRef } from 'react';
import '../css/Dashboard.css';

export default function Dashboard() {
  const containerRef = useRef(null);

  useEffect(() => {
    const divElement = containerRef.current;
    if (!divElement) return;

    const vizElement = divElement.getElementsByTagName('object')[0];

    // Lógica de tamaño original de Tableau
    if (divElement.offsetWidth > 800) {
      vizElement.style.width = '1000px';
      vizElement.style.height = '827px';
    } else if (divElement.offsetWidth > 500) {
      vizElement.style.width = '1000px';
      vizElement.style.height = '827px';
    } else {
      vizElement.style.width = '100%';
      vizElement.style.height = '877px';
    }

    // Inyectar el script de Tableau
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
    vizElement.parentNode.insertBefore(scriptElement, vizElement);

    // Cleanup al desmontar
    return () => {
      if (scriptElement.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <div className="dashboard-container">
      <div className="tableau-container">
        <div
          ref={containerRef}
          className="tableauPlaceholder"
          id="viz1774462177331"
          style={{ position: 'relative' }}
        >
          <noscript>
            <a href="#">
              <img
                alt=" "
                src="https://public.tableau.com/static/images/GS/GSAN/GSANINFORMACION/1_rss.png"
                style={{ border: 'none' }}
              />
            </a>
          </noscript>
          <object className="tableauViz" style={{ display: 'none' }}>
            <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
            <param name="embed_code_version" value="3" />
            <param name="site_root" value="" />
            <param name="name" value="GSAN/GSANINFORMACION" />
            <param name="tabs" value="no" />
            <param name="toolbar" value="yes" />
            <param name="static_image" value="https://public.tableau.com/static/images/GS/GSAN/GSANINFORMACION/1.png" />
            <param name="animate_transition" value="yes" />
            <param name="display_static_image" value="yes" />
            <param name="display_spinner" value="yes" />
            <param name="display_overlay" value="yes" />
            <param name="display_count" value="yes" />
            <param name="language" value="es-ES" />
          </object>
        </div>
      </div>
    </div>
  );
}